import { render } from "./DashboardValuePlayers.vue?vue&type=template&id=3e3806e4"
import script from "./DashboardValuePlayers.vue?vue&type=script&lang=js"
export * from "./DashboardValuePlayers.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__